import React from 'react';

import { Newsletter } from '@utils/backend-api/newsletters';

import NewsletterCard from './NewsletterCard';

interface CategoryProps {
  name: string;
  newsletters: Newsletter[];
  setCurrentNewsletters: React.Dispatch<React.SetStateAction<Newsletter[]>>;
}

const Category = ({ name, newsletters, setCurrentNewsletters }: CategoryProps) => {
  const updateNewsletterSubscription = (id: number, subscribed: boolean) => {
    setCurrentNewsletters((prev) =>
      prev.map((nl) => (nl.id === id ? { ...nl, currentUserSubscribed: subscribed } : nl))
    );
  };
  return (
    <div className="m-auto flex w-full max-w-[1010px] flex-col">
      <h2 className="w-full border-0 border-t border-solid border-t-grayscale-gray pt-8 font-suisse-neue text-subheadline-sm">
        {name}
      </h2>
      <div className="mb-64 mt-56 flex w-full flex-row flex-wrap justify-center gap-x-20 gap-y-56 md:grid md:grid-cols-3 md:gap-x-56">
        {newsletters.map((newsletter) => (
          <NewsletterCard
            key={newsletter.id}
            newsletter={newsletter}
            updateNewsletterSubscription={updateNewsletterSubscription}
          />
        ))}
      </div>
    </div>
  );
};

export default Category;
